import { Link, useLocation, useParams } from "react-router-dom";
import { useMemo, useState } from "react";
import { usePatientsBase, useHubBasePath } from "../../../utils/hubPaths";
import { useAdminHubUi } from "../../../hooks/useAdminAppMode";
import ChatConversationPage from "../common/ChatConversationPage";
import { chatSubtitle, initials } from "../common/ChatThread";
import cs from "../common/chat.module.css";
import s from "../clinic.module.css";

export default function AdminClientChat() {
  const { patientId } = useParams();
  const location = useLocation();
  const patientsBase = usePatientsBase();
  const hubBase = useHubBasePath();
  const isApp = useAdminHubUi();
  const fromChatHub = Boolean(location.state?.fromChatHub);

  const clientNameFromNav = location.state?.clientName;
  const [meta, setMeta] = useState(null);

  const clientName = clientNameFromNav || meta?.client?.full_name || "Клиент";
  const subtitle = useMemo(() => chatSubtitle(meta, "staff"), [meta]);

  const backTo = fromChatHub ? `${hubBase}/chat` : `${patientsBase}/${patientId}`;

  if (isApp) {
    return (
      <ChatConversationPage
        title={clientName}
        subtitle={subtitle}
        backTo={backTo}
        threadType="direct"
        mode="staff"
        patientId={patientId}
        avatarLabel={initials(clientName)}
        avatarUrl={meta?.client?.photo_url}
        fullscreen
        onMeta={setMeta}
      />
    );
  }

  return (
    <div className={s.patientPage}>
      <nav className={s.patientBreadcrumbs} aria-label="Навигация">
        <Link to={patientsBase}>Клиенты</Link>
        <span aria-hidden>/</span>
        <Link to={`${patientsBase}/${patientId}`}>{clientName}</Link>
        <span aria-hidden>/</span>
        <span>Чат</span>
      </nav>
      <div className={cs.chatDesktopCard}>
        <ChatConversationPage
          title={clientName}
          subtitle={subtitle}
          backTo={`${patientsBase}/${patientId}`}
          threadType="direct"
          mode="staff"
          patientId={patientId}
          avatarLabel={initials(clientName)}
        avatarUrl={meta?.client?.photo_url}
          fullscreen={false}
          onMeta={setMeta}
        />
      </div>
    </div>
  );
}
